import * as Sentry from '@sentry/vue'
import { App } from 'vue'

import type { Router } from 'vue-router'

export const SENTRY_ALLOWED_DOMAINS = [
  'preprod.oqtopus.fr',
  'demo.oqtopus.fr',
  'client.closd.com',
]

export function initSentry (app: App, router: Router) {
  // See V2-5638. Following the inclusion of the allowed domains on Sentry's side,
  // we should only initialize Sentry if the current domain is allowed.
  if (SENTRY_ALLOWED_DOMAINS.includes(window.location.hostname)) {
    Sentry.init({
      app,
      dsn: import.meta.env.VUE_APP_SENTRY_DSN,
      // We could also have custom environments for local testing,
      // That way we could filter each local environment if multiple DSN isn't viable
      environment: import.meta.env.VUE_APP_SENTRY_ENVIRONNEMENT || 'local',
      integrations: [
        new Sentry.BrowserTracing({
          routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        }),
      ],
      tracePropagationTargets: ['oqtopus.com', /^\//],
      tracesSampleRate: 0.2,
      release: `closd-front@${__APP_VERSION__}`,
    })

    Sentry.setTags({
      version: __APP_VERSION__,
      revision: __APP_REVISION__,
    })
  }
}
